import TtamIos14SwitchContainer from './container/index.vue';
import TtamIos14SwitchEncourageInfo from './encourage-info/index.vue';
import TtamIos14SwitchAppProfilePage from './app-profile-page/index.vue';
import TtamIos14SwitchQuotaAlert from './quota-alert/index.vue';
import {
  usePropsIos14Disabled,
  usePropsIos14DisabledHint,
  usePropsProfilePageDisabled,
  usePropsAppProfilePageVisible,
  usePropsEncourageInfoVisible,
  usePropsQuotaDesc,
  usePropsQuotaTitle,
  usePropsQuotaType,
  usePropsIos14Quota,
  usePropsQuotaAlertVisible
} from './hooks';
export default {
  TtamIos14SwitchContainer,
  TtamIos14SwitchEncourageInfo,
  TtamIos14SwitchAppProfilePage,
  TtamIos14SwitchQuotaAlert,
  usePropsIos14Disabled,
  usePropsIos14DisabledHint,
  usePropsProfilePageDisabled,
  usePropsAppProfilePageVisible,
  usePropsEncourageInfoVisible,
  usePropsQuotaDesc,
  usePropsQuotaType,
  usePropsQuotaTitle,
  usePropsIos14Quota,
  usePropsQuotaAlertVisible,
};
